import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: '', redirectTo: '/mobile', pathMatch: 'full' },
  // {
  //   path: 'invoices',
  //   loadChildren: () => import('./features/invoices/routes').then((m) => m.INVOICES_ROUTES),
  //   data: { breadcrumb: { alias: 'Invoices' } },
  // },
  // {
  //   path: 'invoice-log',
  //   loadChildren: () => import('./features/invoice-log/routes').then((r) => r.INVOICE_LOG_ROUTES),
  //   data: { breadcrumb: { alias: 'Invoice log' } },
  // },
  // {
  //   path: 'settings',
  //   loadChildren: () => import('./features/settings/routes').then((m) => m.SETTINGS_ROUTES),
  // },
  {
    path: 'mobile',
    loadChildren: () => import('./mobile/routes').then((m) => m.MOBILE_ROUTES),
  },
  {
    path: '**',
    loadChildren: () => import('./features/page-not-found/routes').then((m) => m.PAGE_NOT_FOUND_ROUTES),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
